module.exports = "<div class=\"table\">\r\n    <div class=\"row\">\r\n        test\r\n    </div>\r\n</div>"